import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

import App from './App';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
